module.exports = __webpack_public_path__ + "static/img/tx_4.13a19cd4.png";